import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { Button, FormGroup, Input, Label } from 'reactstrap';
import api from '../../../api';
import './index.css';

// const datasource_configs = [
//   'datasource_host',
//   'datasource_port',
//   'datasource_user',
//   'datasource_secret',
//   'datasource_schema_name',
// ]
export default class PrestoDataSource extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateNew: this.props.isCreateNew || false,
      datasource: this.props.datasource || {
        name: '',
        code_name: '',
        description: '',
        datasource_type: this.props.datasourceType,
        extra_data: {
          ignored_datasets: '',
        },
        datasource_host: '',
        datasource_port: '',
        datasource_user: '',
        datasource_secret: '',
        datasource_catalog: '',
        datasource_schema_name: '',
      }
    };
  }
  updateAttr(attribute, value) {
    const { datasource } = this.state;
    datasource[attribute] = value;
    this.setState({ datasource });
  }
  updateExtraAttr(attribute, value) {
    const { datasource } = this.state;
    datasource.extra_data[attribute] = value;
    this.setState({ datasource });
  }
  updateDatasource() {
    const { datasource, isCreateNew } = this.state;
    const { onDatasourceUpdated } = this.props;
    delete datasource.object_type;
    delete datasource.databases;

    api.fetchAPI({
      method: isCreateNew ? 'post' : 'put',
      uri: 'datasources',
      body: datasource,
      success: (response) => {
        if (response.status === 'ok') {
          this.setState({ datasource: response.datasource });
          alert('Datasource is saved');
          if (onDatasourceUpdated) {
            onDatasourceUpdated(response.datasource);
          }
        } else {
          alert('Fail to create new datasource');
        }
      },
      error: (error) => {
        console.error(error);
      }
  });
  }
  render() {
    const { datasource, isCreateNew } = this.state;
    return (
      <div className="">
        <h5>Presto</h5>
        <FormGroup>
          <Label>Code name</Label>
          <Input
            type="text"
            value={datasource.code_name}
            placeholder="my-data-source"
            onChange={(e) => this.updateAttr('code_name', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Name</Label>
          <Input
            type="text"
            value={datasource.name}
            onChange={(e) => this.updateAttr('name', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Description</Label>
          <TextareaAutosize
            className="form-control"
            type="textarea"
            value={datasource.description}
            onChange={(e) => this.updateAttr('description', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Host / Server address</Label>
          <Input
            type="text"
            value={datasource.datasource_host}
            onChange={(e) => this.updateAttr('datasource_host', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Port</Label>
          <Input
            type="text"
            value={datasource.datasource_port}
            onChange={(e) => this.updateAttr('datasource_port', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>User</Label>
          <Input
            type="text"
            value={datasource.datasource_user}
            onChange={(e) => this.updateAttr('datasource_user', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Password</Label>
          <Input
            type="password"
            value={datasource.datasource_secret}
            onChange={(e) => this.updateAttr('datasource_secret', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Catalog</Label>
          <Input
            type="text"
            value={datasource.datasource_catalog}
            onChange={(e) => this.updateAttr('datasource_catalog', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Label>Schema</Label>
          <Input
            type="text"
            value={datasource.datasource_schema_name}
            onChange={(e) => this.updateAttr('datasource_schema_name', e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <Button
            color="success"
            onClick={() => this.updateDatasource()}
          >
            {isCreateNew ? 'Create' : 'Save'}
          </Button>
        </FormGroup>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/connectors/Presto/index.js